import { render, staticRenderFns } from "./iconList.vue?vue&type=template&id=c37c5438"
import script from "./iconList.vue?vue&type=script&lang=js"
export * from "./iconList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports